export default "__VITE_PUBLIC_ASSET__1ba5d6bb__"